function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 0C3.6 0 0 3.6 0 8C0 11.3 2 14.1 4.8 15.3C4.8 14.7 4.79999 14.1 4.89999 13.5C5.09999 12.8 5.89999 9.1 5.89999 9.1C5.89999 9.1 5.60001 8.6 5.60001 7.8C5.60001 6.6 6.30001 5.7 7.10001 5.7C7.80001 5.7 8.2 6.2 8.2 6.9C8.2 7.6 7.7 8.7 7.5 9.7C7.3 10.5 7.9 11.2 8.8 11.2C10.3 11.2 11.3 9.3 11.3 6.9C11.3 5.1 10.1 3.8 8 3.8C5.6 3.8 4.10001 5.6 4.10001 7.6C4.10001 8.3 4.30001 8.8 4.60001 9.2C4.70001 9.4 4.8 9.4 4.7 9.6C4.7 9.7 4.6 10.1 4.5 10.2C4.4 10.4 4.30001 10.5 4.10001 10.4C3.00001 9.9 2.5 8.7 2.5 7.3C2.5 5 4.4 2.3 8.2 2.3C11.3 2.3 13.3 4.5 13.3 6.9C13.3 10 11.6 12.4 9 12.4C8.1 12.4 7.3 11.9 7 11.4C7 11.4 6.49999 13.2 6.39999 13.6C6.19999 14.2 5.90001 14.8 5.60001 15.3C6.30001 15.5 7.09999 15.6 7.89999 15.6C12.3 15.6 15.9 12 15.9 7.6C16 3.6 12.4 0 8 0Z",
  fill: "white"
});

function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.7ae5c089.svg";
export { ForwardRef as ReactComponent };